import { waLink, track } from "@/constants/site";
import Reveal from "@/components/base/Reveal";

const PROBLEMS = [
  { icon: "ri-close-circle-line", label: "Não liga" },
  { icon: "ri-temp-hot-line", label: "Superaquecimento" },
  { icon: "ri-speed-mini-line", label: "Perda de força" },
  { icon: "ri-volume-up-line", label: "Ruído anormal" },
  { icon: "ri-pulse-line", label: "Vibração" },
  { icon: "ri-fire-line", label: "Cheiro de queimado" },
  { icon: "ri-flashlight-line", label: "Falha elétrica" },
  { icon: "ri-lock-line", label: "Travamento" },
];

export default function MotorProblems() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <Reveal>
          <h2 className="max-w-3xl font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            Seu motor está mostrando que algo não está certo?
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {PROBLEMS.map((p, i) => (
            <Reveal key={p.label} delay={i * 40}>
              <div className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-4 transition-colors hover:border-accent-300 hover:bg-accent-50">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${p.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="text-sm font-semibold text-foreground-800">{p.label}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-10 flex flex-col items-start gap-6 rounded-lg border border-background-200 bg-background-100 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <p className="max-w-2xl text-base leading-relaxed text-foreground-700">
              Esses sinais podem ter diferentes causas. Uma avaliação técnica ajuda a
              identificar o problema e definir a solução adequada.
            </p>
            <a
              href={waLink("Olá! Meu motor está apresentando problemas e preciso de uma avaliação técnica.")}
              target="_blank"
              rel="noreferrer"
              onClick={() => track("whatsapp_click")}
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-chat-3-line text-xl" aria-hidden="true" />
              Falar sobre meu equipamento
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}